import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Our Components
import { LoginComponent } from './components/login/login.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ForgotPasswordComponent } from './components/forgot_password/forgot_password.component';
import { ChangePasswordComponent } from './components/change_password/change_password.component';
import { AuthGuardService } from './services/auth_guard_service.service';
import { HomeComponent } from './components/home/home.component';
import { RegistrationConfirmationComponent } from './components/registration_confirmation/registration_confirmation.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { ProductViewComponent } from './components/product-view/product-view.component';
import { NotificationsManagementComponent } from './components/notifications-management/notifications-management.component';
import { SubscriptionManagementComponent } from './components/subscription-management/subscription-management.component';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
  },
  {
    path: 'Provider-Profile/:id',
    component: ProfilePageComponent,
  },
  {
    path: 'notifications-management',
    component: NotificationsManagementComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'subscription-management',
    component: SubscriptionManagementComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'registration',
    component: RegistrationComponent,
  },
  {
    path: 'registration-confirmation',
    component: RegistrationConfirmationComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'change-password/:id',
    component: ChangePasswordComponent,
  },
  {
    path: 'product-view/:id',
    component: ProductViewComponent
  },
  // {
  //   path: 'profile',
  //   component: ProfileComponent,
  //   canActivate: [AuthGuardService],
  // },
  {
    path: 'terms',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'payment-success/:id',
    component: PaymentSuccessComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
